var Nam = "Male";
var Region = "Region";
var Community = "Community";
var enLang = {
	"Thông tin người nhận hàng": "Delivery info",
	"Họ tên": "Name",
	"Nhập tên của bạn": "Input name",
	"Số điện thoại": "Phone number",
	"Nhập số điện thoại": "Input phone number",
	"Nhập email của bạn": "Input email",
	"Địa chỉ nhận hàng": "Address",
	"Tỉnh/Thành phố": "Province",
	"Chọn tỉnh/thành phố": "Select province",
	"Quận/Huyện": "District",
	"Chọn quận/huyện": "Input district",
	"Phường/Xã": "Ward",
	"Chọn phường/xã": "Select ward",
	"Địa chỉ cụ thể": "Detail address",
	"Số nhà, ngõ, tên đường...": "No./Street...",
	"Đặt làm mặc định": "Set as default",
	"Hủy bỏ": "Cancel",
	"Lưu địa chỉ": "Save",
	"Vui lòng nhập tên người nhận": "Please input receiver name",
	"Số điện thoại không đúng định dạng": "Invalid phone number format",
	"Vui lòng nhập đúng số điện thoại người nhận": "Please input valid phone number",
	"Địa chỉ email không đúng định dạng": "Invalid email format",
	"Trường bắt buộc": "Required fields",
	"Vui lòng nhập địa chỉ nhận hàng": "Please input address",
	"Họ tên người nhận": "Receiver Name",
	"Số điện thoại người nhận": "Receiver phone number",
	"Chọn Tỉnh/Thành phố": "Province",
	"Thành phố...": "Province...",
	"Chọn Quận/Huyện": "District",
	"Quận...": "District...",
	"Chọn Phường/Xã": "Select ward",
	"Phường...": "Ward...",
	"Địa chỉ cụ thể (Số nhà, tên đường...)": "Detailed address",
	"Số nhà...": "No...",
	"Hoàn tất": "Complete",
	"Không tìm thấy địa chỉ của bạn": "Address not found",
	"Mặc định": "Default",
	"Bạn chưa tạo sổ địa chỉ": "You have no address book",
	"src.mobile.AddressList.AddressList.0": "This platform does not allow to add new address",
	"src.mobile.AddressList.AddressList.1": "This platform does not allow to add new address",
	"Thêm mới địa chỉ": "Add new",
	"Chỉnh sửa": "Edit",
	"Xóa": "Delete",
	"Hủy": "Cancel",
	"Bạn có muốn xóa sổ địa chỉ này?": "Are you sure to delete address?",
	"Xác nhận": "Confirm",
	"MẶC ĐỊNH": "DEFAULT",
	"Địa chỉ": "Address",
	"Điện thoại": "Phone",
	"${label} không được bỏ trống": "${label} cannot be blank",
	"${label} không đúng định dạng": "${label} is invalid format",
	"Có lỗi xảy ra. Vui lòng thử lại sau": "An error has occurred. Please retry later",
	"Nhập số": "Input",
	"Giới tính": "Gender",
	Nam: Nam,
	"Nữ": "Female",
	"Khác": "Other",
	"Họ và tên": "Full name",
	"Nhập họ và tên": "Input full name",
	"Ngày sinh": "Date of birth",
	"Địa chỉ khách hàng": "Customer address",
	"${label} không được để trống": "${label} cannot be blank",
	"${label} không dài quá ${max} kí tự": "${label} cannot exceed ${max} characters",
	"${label} có độ dài tối thiểu ${min} kí tự": "${label} not less than ${min} characters",
	"${label} không hợp lệ": "${label} is invalid",
	"${label} có độ dài tối đa ${max} kí tự": "${label} has maximum length of ${max} characters",
	"${label} phải trước ngày hiện tại": "${label} must be before the current date",
	Region: Region,
	Community: Community
};

export { Community, Nam, Region, enLang as default };
